import React, { useEffect, useRef, useState } from 'react';
export default function StripRawHtml(props) {
    var fields = props.fields, children = props.children;
    var contentElementRef = useRef(null);
    var _a = useState(fields.content || ""), content = _a[0], setContent = _a[1];
    function removeScriptTags(inputString) {
        if (!inputString)
            return inputString;
        // Use a regular expression to match and remove script tags
        var withoutScripts = inputString.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
        return withoutScripts;
    }
    function loadScripts(array, callback) {
        var loader = function (scriptSrc, handler) {
            if (scriptSrc.dataset["executelocal"] == "1") {
                if ((scriptSrc.textContent || "").length) {
                    try {
                        // console.log("execute script:", scriptSrc.textContent);
                        eval.call(window, scriptSrc.textContent); // TODO: check the script order exectution
                    }
                    catch (e) {
                        console.log("dynamic script code execution fail", e);
                    }
                }
                handler();
                return;
            }
            //var script = document.createElement("script");
            //script.src = scriptSrc.src;
            //script.async = false;
            scriptSrc.onload = (function () {
                scriptSrc.onload = null;
                handler();
            }).bind(this);
            if (!contentElementRef.current) {
                console.warn("Add dynamic scripts failed - Target content element reference is null");
            }
            contentElementRef.current && contentElementRef.current.appendChild(scriptSrc);
        };
        (function run() {
            if (array.length > 0) {
                loader(array.shift(), run);
            }
            else {
                callback && callback();
            }
        })();
    }
    useEffect(function () {
        var currentContentElement = contentElementRef.current;
        // console.log("strip content: ", currentContentElement);
        var srcScripts = [];
        if (fields.content && fields.content.indexOf("script") >= 0) {
            var parseContent = new DOMParser().parseFromString(fields.content, 'text/html');
            var scripts = parseContent.getElementsByTagName('script');
            if (scripts && scripts.length > 0) {
                for (var i = 0; i < scripts.length; i++) {
                    //if (!(scripts[i].src || "").length) continue;
                    //content = content.split(scripts[i].outerHTML.split(`async=""`).join("async")).join("");
                    srcScripts.push(scripts[i]);
                }
            }
            //setSrcScripts(srcScript);
            // Serialize the modified DOM back to a string
            var contentWithoutScripts = removeScriptTags(fields.content);
            setContent(contentWithoutScripts);
        }
        if (srcScripts.length && currentContentElement) {
            var scriptElements_1 = [];
            var scriptsForExecution_1 = [];
            srcScripts.forEach(function (scriptSrc) {
                var script = document.createElement('script');
                //Object.assign(script, scriptSrc);
                // script.integrity = scriptSrc.integrity;
                // script.crossOrigin = scriptSrc.crossOrigin;
                script.type = scriptSrc.type;
                script.src = scriptSrc.src;
                script.async = false;
                if (!scriptSrc.src) {
                    script.dataset["executelocal"] = "1";
                    script.textContent = scriptSrc.textContent;
                    scriptsForExecution_1.push(script);
                }
                else {
                    scriptElements_1.push(script);
                    scriptsForExecution_1.push(script);
                }
                //currentContentElement.appendChild(script);
            });
            loadScripts(scriptsForExecution_1, null);
            return function () {
                scriptElements_1 && scriptElements_1.forEach(function (scriptEl) {
                    try {
                        currentContentElement && currentContentElement.removeChild(scriptEl);
                    }
                    catch (e) {
                        console.log(e);
                    }
                });
            };
        }
    }, []);
    return (React.createElement("div", { className: "strip-raw-html", ref: contentElementRef, dangerouslySetInnerHTML: { __html: content } }));
}
